export enum EnumPlayerFormat {
  H5LIVE = "h5live",
  JPEG = "jpeg",
  MJPEG = "mjpeg",
  HLS = "hls",
  RTMP = "rtmp",
  WEBRTC = "webrtc",
  MP3 = "mp3",
  VORBIS = "vorbis",
  VIDEOSDK = "videosdk",
}
